import { Observable } from 'rxjs';

export abstract class SearchDataHttpService {
	abstract simpleSearch<T = any>(criteria: ISimpleSearchCriteria): Observable<T>;
}

export interface ISimpleSearchCriteria {
	searchText: string;
	maxResultCount?: number;
	showClosedTasks?: boolean;
	showRejectedTasks?: boolean;
	searchTypes?: number[];
}
